import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Subject} from 'rxjs';
import {first, takeUntil} from 'rxjs/operators';
import {SystemSettingsService} from '../../../service/system-settings.service';
import * as fromRoot from '../../../store/app.reducers';
import {Store} from '@ngrx/store';
import {State} from '../../../store/user/user.reducers';
import {ACTIVE_OFFER_STATES, AUCTION_TYPES} from '../../../misc/constants';

/**
 * The footer of a tile. This is only displayed at some positions in some offer states.
 */
@Component({
  selector: 'ucs-default-footer',
  templateUrl: './default-footer.component.html',
  styleUrls: ['./default-footer.component.scss'],
  standalone: false
})
export class DefaultFooterComponent implements OnInit, OnDestroy {
  //Offer data coming from OfferItemDto or LatestOfferDataDto
  @Input() offer: AuctionOfferDto & BuyNowOfferDto & EnforcedAuctionOfferDto & LatestOfferDataDto;
  @Input() vehicle: VehicleItemBaseDto | VehicleBaseDto | VehicleDetailDto;
  @Input() channel: DistributionChannel;
  @Input() startPrice: PriceDto;
  @Input() showOfferLink: boolean;
  @Input() footerStatus: VehicleFooterStatus;
  @Input() hideFooterStatus = false;
  @Input() extraTax: ExtraTaxDto;
  @Input() scopeSection: AppScope;
  @Input() disableBidding: boolean;
  @Input() thermalWindowAffected = false;
  @Output() linkToOfferClicked = new EventEmitter<void>();
  showGrossProfit = false;
  userInfo: UserInfoDto;
  userState: State;
  protected readonly ACTIVE_OFFER_STATES = ACTIVE_OFFER_STATES;
  protected readonly AUCTION_TYPES = AUCTION_TYPES;
  protected readonly VehicleItemBaseDto: VehicleItemBaseDto;
  private unsubscribe: Subject<void> = new Subject<void>();

  constructor(private store: Store<fromRoot.AppState>,
              private systemSettingsService: SystemSettingsService) {
  }

  ngOnInit() {
    this.store.select(fromRoot.getUserInfo)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(userInfo => {
        if (userInfo) {
          this.userInfo = userInfo;
        }
      });

    this.systemSettingsService.isSystemFeatureActivatedForChannel('GROSS_PROFIT_DISPLAY', this.channel)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(showGrossProfit => {
        this.showGrossProfit = showGrossProfit;
      });
    this.store
      .select(fromRoot.getUserState)
      .pipe(first())
      .subscribe(userState => {
        if (userState) {
          this.userState = userState;
        }
      });

  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
